import Chip, {chipClasses} from "@mui/material/Chip";
import {FC} from "react";
import {str2arr} from "@/helper/method";

interface ReviewStatusProps {
    processorIds: string;
    auditStatus: number;
    nodeNames: string;
    writeStatusId?: number
    authId?: number
}

export const ReviewStatus: FC<ReviewStatusProps> = ({nodeNames, processorIds, authId, writeStatusId, auditStatus}) => {
    let color: string = ''
    let label: string = nodeNames || "已通过"
    if (writeStatusId == 4) {
        label = "待分配"
        color = "rgba(204,214,138,0.63)"
    } else if (writeStatusId == 5) {
        label = "待领取"
        color = "#d3e1ec"
    } else if (auditStatus == 2) {
        label = "已通过"
        color = "#fff1cc"
    } else if (auditStatus == 1) {
        const ids: number[] = str2arr(processorIds)
        if (ids.indexOf(authId!) > -1) {
            color = '#ffe4ec'
        } else {
            color = '#d2f9f4'
        }
    }
    return <Chip size={'medium'} sx={{backgroundColor: color, border: 'none', [`& .${chipClasses.label}`]: {fontWeight: 400, color: '#000'}}} label={label} variant={'filled'}/>
}